import { render } from "./_MenuMainLink.vue?vue&type=template&id=538932f2"
import script from "./_MenuMainLink.vue?vue&type=script&lang=js"
export * from "./_MenuMainLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/evoove-zcd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__